import { render } from "./Index.vue?vue&type=template&id=563b71e4&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=563b71e4&lang=scss"
import "./Index.vue?vue&type=style&index=1&id=563b71e4&scoped=true&lang=css"

import exportComponent from "/home/jenkins/workspace/xujiaxin-linchuang-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-563b71e4"]])

export default __exports__